import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme.js';
import LoginPage from './components/LoginPage.jsx';
import SignupPage from './components/SignupPage.jsx';
import AdminDashboard from './components/AdminDashboard.jsx';
import FormPage from './components/FormPage.jsx';
import PrivateRoute from './components/PrivateRoute.jsx';
import QRDetailPage from './components/QRDetailPage.jsx';
import QRViewRouter from './components/QRViewRouter.jsx';
import UserManagement from './components/UserManagement.jsx';
import PrivacyPage from './components/PrivacyPage.jsx';
import TermsPage from './components/TermsPage.jsx';
import ContactPage from './components/ContactPage.jsx';
import Footer from './components/Footer.jsx';
import { AnimatePresence, motion } from 'framer-motion';

function App() {

  const pageVariants = {
    initial: {
      opacity: 0,
      x: "-100vw"
    },
    in: {
      opacity: 1,
      x: 0
    },
    out: {
      opacity: 0,
      x: "100vw"
    }
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.5
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/login" element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                style={{ width: '100%', height: '100%' }}
              >
                <LoginPage />
              </motion.div>
            } />
            <Route path="/signup" element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                style={{ width: '100%', height: '100%' }}
              >
                <SignupPage />
              </motion.div>
            } />
            <Route
              path="/admin-dashboard"
              element={
                <PrivateRoute>
                  <motion.div
                    initial="initial"
                    animate="in"
                    exit="out"
                    variants={pageVariants}
                    transition={pageTransition}
                    style={{ width: '100%', height: '100%' }}
                  >
                    <AdminDashboard />
                  </motion.div>
                </PrivateRoute>
              }
            />
            <Route
              path="/form"
              element={
                <PrivateRoute>
                  <motion.div
                    initial="initial"
                    animate="in"
                    exit="out"
                    variants={pageVariants}
                    transition={pageTransition}
                    style={{ width: '100%', height: '100%' }}
                  >
                    <FormPage />
                  </motion.div>
                </PrivateRoute>
              }
            />
            <Route
              path="/user-management"
              element={
                <PrivateRoute>
                  <motion.div
                    initial="initial"
                    animate="in"
                    exit="out"
                    variants={pageVariants}
                    transition={pageTransition}
                    style={{ width: '100%', height: '100%' }}
                  >
                    <UserManagement />
                  </motion.div>
                </PrivateRoute>
              }
            />
            <Route path="/package/:packageId" element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                style={{ width: '100%', height: '100%' }}
              >
                <QRViewRouter />
              </motion.div>
            } />
            <Route path="/hindalco" element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                style={{ width: '100%', height: '100%' }}
              >
                <QRViewRouter />
              </motion.div>
            } />
            <Route path="/privacy" element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                style={{ width: '100%', height: '100%' }}
              >
                <PrivacyPage />
              </motion.div>
            } />
            <Route path="/terms" element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                style={{ width: '100%', height: '100%' }}
              >
                <TermsPage />
              </motion.div>
            } />
            <Route path="/contact" element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                style={{ width: '100%', height: '100%' }}
              >
                <ContactPage />
              </motion.div>
            } />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </AnimatePresence>
        <Footer />
    </ThemeProvider>
  );
}

export default App;